import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { SectionHeader, CategoryIcon, DemoBadge } from '@/components/common/Primitives';
import { useData } from '@/hooks/useData';
import { useIsVisitor, VisitorOnly } from '@/hooks/useIsVisitor';
import { useSeo } from '@/lib/seo';

export default function Categories() {
  useSeo({ title: 'Categorias', description: 'Categorias empresariais da rede.' });
  const { categories, publicCompanies, publicOpportunities } = useData();
  const isVisitor = useIsVisitor();
  return (
    <div className="container-x py-10 sm:py-14">
      <SectionHeader
        eyebrow="Setores"
        title="Categorias empresariais"
        text={isVisitor
          ? 'Navegue pelos setores da rede. As quantidades refletem os dados de exemplo deste protótipo.'
          : 'Navegue pelos setores da rede e veja as empresas e oportunidades de cada um.'}
        right={<VisitorOnly><DemoBadge label="Contagens demonstrativas" /></VisitorOnly>}
      />
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="categories-grid">
        {categories.filter((c) => c.active).map((c) => {
          const nc = publicCompanies.filter((x) => x.categoryId === c.id || (x.extraCategoryIds || []).includes(c.id)).length;
          const no = publicOpportunities.filter((x) => x.categoryId === c.id).length;
          return (
            <Link key={c.id} to={`/empresas?categoryId=${c.id}`} className="surface surface-hover group flex items-center gap-4 p-4" data-testid={`category-card-${c.id}`}>
              <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl border border-white/10 bg-[#0b1220]">
                <CategoryIcon name={c.icon} className="h-5 w-5 text-primary" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-semibold">{c.name}</div>
                <div className="mt-0.5 font-mono text-[11px] text-muted-foreground">{nc} empresas · {no} oportunidades</div>
              </div>
              <ArrowUpRight className="h-4 w-4 text-muted-foreground transition-colors group-hover:text-primary" />
            </Link>
          );
        })}
      </div>
    </div>
  );
}